import React from 'react'
import { Field } from 'formik'
import CurrencyInput from 'react-currency-input-field'
import { ListInputProps } from '../types'

const ListInput: React.FC <ListInputProps> = ({ inputID, inputName, inputType, inputMask, setFieldValue, value }) => {

    const inputProps = {
        id: inputID,
        name: inputName,
        type: inputType ?? 'text',
    }

    return(

        <>
            {(inputMask === 'currency' && (
                <CurrencyInput 
                    {...inputProps} 
                    decimalSeparator=","
                    groupSeparator="."
                    value={value}
                    onValueChange={text => setFieldValue!(inputName, text)}
                />
            )) || <Field {...inputProps} />}
        </>

    )

}

export default ListInput